(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	var btns = document.querySelectorAll("[data-toggle-active] .toggle-button");

	if (btns === undefined || !btns.length) {
		throw 'no tab content';
	}
	else {
		var currentURL = window.location.href;
		var url = new URL(currentURL);
		var categoryString = url.searchParams.get("category");

		for (var i = 0; i < btns.length; i++) {
			var thisButton = btns[i];

			if (thisButton.innerHTML === categoryString) {
				thisButton.parentElement.classList.add('active');
			}
			else if (categoryString == null) {
				btns[0].parentElement.classList.add('active');
			}
		}
	}

})();
